var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 38,
    viewBox: "0 0 49 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5082 8.57031C40.9957 8.57031 48.7582 14.8984 48.7582 22.6328C48.7582 26.0312 47.2488 29.1953 44.7691 31.6562C45.0926 32.8281 45.6316 34.3516 46.7098 35.7578C47.3566 36.5781 46.7098 37.75 45.7395 37.6328C42.5051 37.2813 39.9176 36.3437 38.0848 35.5234C36.0363 36.2266 33.7723 36.5781 31.4004 36.5781C21.9129 36.5781 14.1504 30.25 14.1504 22.5156C14.2582 14.8984 22.0207 8.57031 31.5082 8.57031Z",
    fill: "#3E80C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4922 0.25C8.00469 0.25 0.242188 6.57812 0.242188 14.3125C0.242188 17.7109 1.75156 20.875 4.23125 23.3359C3.90781 24.5078 3.36875 26.0312 2.29062 27.4375C1.64375 28.2578 2.29063 29.4297 3.26094 29.3125C6.49531 28.9609 9.08281 28.0234 10.9156 27.2031C12.9641 27.9062 15.2281 28.2578 17.6 28.2578C27.0875 28.2578 34.85 21.9297 34.85 14.1953C34.7422 6.57812 26.9797 0.25 17.4922 0.25Z",
    fill: "#60A1EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94531 16.6562C11.1362 16.6562 12.1016 15.6069 12.1016 14.3125C12.1016 13.0181 11.1362 11.9688 9.94531 11.9688C8.75445 11.9688 7.78906 13.0181 7.78906 14.3125C7.78906 15.6069 8.75445 16.6562 9.94531 16.6562Z",
    fill: "#FCFCFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4922 16.6562C18.6831 16.6562 19.6484 15.6069 19.6484 14.3125C19.6484 13.0181 18.6831 11.9688 17.4922 11.9688C16.3013 11.9688 15.3359 13.0181 15.3359 14.3125C15.3359 15.6069 16.3013 16.6562 17.4922 16.6562Z",
    fill: "#FCFCFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0391 16.6562C26.2299 16.6562 27.1953 15.6069 27.1953 14.3125C27.1953 13.0181 26.2299 11.9688 25.0391 11.9688C23.8482 11.9688 22.8828 13.0181 22.8828 14.3125C22.8828 15.6069 23.8482 16.6562 25.0391 16.6562Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.50bedbd802eac60995151c60281a2418.svg";
export { ForwardRef as ReactComponent };